import fetch from "isomorphic-fetch"

export async function fetchData() {
  const data = await fetch("https://euwpsub0smazf02.azurewebsites.net/api/api")
  const jsonData = await data.json()
  return jsonData
}
